import { render, staticRenderFns } from "./tableForm.vue?vue&type=template&id=1172fe92&scoped=true"
import script from "./tableForm.vue?vue&type=script&lang=js"
export * from "./tableForm.vue?vue&type=script&lang=js"
import style0 from "./tableForm.vue?vue&type=style&index=0&id=1172fe92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172fe92",
  null
  
)

export default component.exports